module.exports = __webpack_public_path__ + "static/media/candy-corn.98b6309e.svg";